
export const logAction = (user, actionType, details) => {
  try {
    const logs = JSON.parse(localStorage.getItem('audit_logs') || '[]');
    const newLog = {
      id: Date.now().toString(36) + Math.random().toString(36).substr(2),
      timestamp: new Date().toISOString(),
      userId: user.id,
      userName: user.name,
      actionType, // e.g., 'CREATE', 'UPDATE', 'DELETE', 'LOGIN'
      details,
    };
    // Keep only last 1000 logs
    const updatedLogs = [newLog, ...logs].slice(0, 1000);
    localStorage.setItem('audit_logs', JSON.stringify(updatedLogs));
  } catch (error) {
    console.error('Failed to log action:', error);
  }
};

export const createNotification = (userId, type, message) => {
  try {
    const notifications = JSON.parse(localStorage.getItem('notifications') || '[]');
    const newNotification = {
      id: Date.now().toString(36) + Math.random().toString(36).substr(2),
      timestamp: new Date().toISOString(),
      userId, // 'ALL' or specific userId
      type, // 'INFO', 'WARNING', 'SUCCESS', 'ERROR'
      message,
      read: false
    };
    const updated = [newNotification, ...notifications].slice(0, 50);
    localStorage.setItem('notifications', JSON.stringify(updated));
  } catch (error) {
    console.error('Failed to create notification', error);
  }
};
